import auth from "@/services/ExerciseInitAuth"

const categoriesList = query =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/question_categories/`, {
    params: query
  });

export default {
  categoriesList
}